import { getAppVersionNum } from '../../application/helper/appUtils';
import {
  TBridgeMap,
  IVersionDic,
  OS,
  withErrorHandler,
  createVersionChecker,
  os,
} from './index';

const iosVersionDic: IVersionDic = {
  requestExternalBrowser: [{ version: '02.01.33' }],
  requestWebView: [{ version: '02.01.33' }],
  requestWebViewFinish: [{ version: '02.01.33' }],
  requestGoMain: [{ version: '02.01.33' }],
  requestAddService: [
    { version: '02.01.33' },
    { version: '02.01.36', tag: 'CREDIT' },
  ],
  onClickHWKeyBtn: [{ version: '02.01.33' }],
  requestCustomerInfo: [{ version: '02.01.33' }],
  receiveCustomerInfo: [{ version: '02.01.33' }],
  requestAuthCheck: [{ version: '02.01.33' }],
  receiveAuthCheck: [{ version: '02.01.33' }],
  requestUserCertIssuanceStatus: [{ version: '02.01.34' }],
  onReceiveUserCertIssuanceStatus: [{ version: '02.01.34' }],
  requestUserCertIssuance: [{ version: '02.01.34' }],
  onReceiveUserCertIssuance: [{ version: '02.01.34' }],
  requestCertSignStandby: [{ version: '02.01.34' }],
  onCertSignResult: [{ version: '02.01.34' }],
};
const aosVersionDic: IVersionDic = {
  requestExternalBrowser: [{ version: '02.01.39' }],
  requestWebView: [{ version: '02.01.39' }],
  requestWebViewFinish: [{ version: '02.01.39' }],
  requestGoMain: [{ version: '02.01.39' }],
  requestAddService: [
    { version: '02.01.39' },
    { version: '02.01.41', tag: 'CREDIT' },
  ],
  onClickHWKeyBtn: [{ version: '02.01.39' }],
  requestCustomerInfo: [{ version: '02.01.39' }],
  receiveCustomerInfo: [{ version: '02.01.39' }],
  requestAuthCheck: [{ version: '02.01.39' }],
  receiveAuthCheck: [{ version: '02.01.39' }],
  requestUserCertIssuanceStatus: [{ version: '02.01.40' }],
  onReceiveUserCertIssuanceStatus: [{ version: '02.01.40' }],
  requestUserCertIssuance: [{ version: '02.01.40' }],
  onReceiveUserCertIssuance: [{ version: '02.01.40' }],
  requestCertSignStandby: [{ version: '02.01.40' }],
  onCertSignResult: [{ version: '02.01.40' }],
};

const createBridgeKt = (os: OS) => {
  const iosRequest = (method: any, args: any) => {
    console.log('kt ios', method, args);
    args = args ?? {};
    args = Object.entries(args)
      .map((e) => {
        if (method === 'requestExternalBrowser' && e[0] === 'url' && e[1]) {
          // @ts-ignore
          return `url=${encodeURIComponent(e[1])}`;
        } else {
          return e.join('=');
        }
      })
      .join('&');
    window.location.href = `LoanKTPassCall://${method}?${args}`;
  };

  const iosReceive = (eventName: any, callback: any) => {
    console.log(eventName, callback);
    window[eventName] = callback;
  };

  // buttonType: B | C | N
  // thirdLoanYn: Y | N
  const aosRequest = (method: any, args: any) => {
    console.log('kt aos', method, args);
    if (method === 'requestWebView') {
      const { url, title, buttonType } = args;
      window?.LoanKTPassCall[method](url, title, buttonType);
    } else if (method === 'requestExternalBrowser') {
      const { url } = args;
      window?.LoanKTPassCall[method](url);
    } else if (method === 'requestAddService') {
      const {
        type,
        url,
        noneMemberUrl,
        freeMemberUrl,
        paidMemberUrl,
        needMoveAfterJoin,
      } = args;
      if (type === 'CREDIT') {
        window?.LoanKTPassCall[method](
          type,
          url,
          noneMemberUrl,
          freeMemberUrl,
          paidMemberUrl,
          needMoveAfterJoin,
        );
      } else {
        const appVersion = getAppVersionNum('kt');
        if (appVersion >= 200010041) {
          window?.LoanKTPassCall[method](type, url, '', '', '', '');
        } else {
          window?.LoanKTPassCall[method](type, url);
        }
      }
    } else if (method === 'requestCustomerInfo') {
      const { thirdLoanYn } = args;
      window?.LoanKTPassCall[method](thirdLoanYn);
    } else if (method === 'requestAuthCheck') {
      const { pisAppToken } = args;
      window?.LoanKTPassCall[method](pisAppToken);
    } else {
      window?.LoanKTPassCall[method]();
    }
  };

  const aosReceive = (eventName: any, callback: any) => {
    console.log(eventName, callback);
    window[eventName] = callback;
  };

  const bridge = (request: any, receive: any) => {
    return {
      requestExternalBrowser: ({ url }: any) =>
        request('requestExternalBrowser', { url }),
      requestWebView: ({ url, title, buttonType }: any) =>
        request('requestWebView', { url, title, buttonType }),
      requestWebViewFinish: () => request('requestWebViewFinish'),
      requestGoMain: () => request('requestGoMain'),
      requestAddService: ({
        type,
        url,
        noneMemberUrl,
        freeMemberUrl,
        paidMemberUrl,
        needMoveAfterJoin,
      }: any) =>
        request('requestAddService', {
          type,
          url,
          noneMemberUrl,
          freeMemberUrl,
          paidMemberUrl,
          needMoveAfterJoin,
        }),
      onClickHWKeyBtn: ({ callback }: any) =>
        receive('onClickHWKeyBtn', callback),
      requestCustomerInfo: ({ thirdLoanYn }: any) =>
        request('requestCustomerInfo', { thirdLoanYn }),
      receiveCustomerInfo: ({ callback }: any) =>
        receive('receiveCustomerInfo', callback),
      requestAuthCheck: ({ pisAppToken }: any) =>
        request('requestAuthCheck', { pisAppToken }),
      receiveAuthCheck: ({ callback }: any) =>
        receive('receiveAuthCheck', callback),
      requestUserCertIssuanceStatus: () =>
        request('requestUserCertIssuanceStatus'),
      onReceiveUserCertIssuanceStatus: ({ callback }: any) =>
        receive('receiveUserCertIssuanceStatus', callback),
      requestUserCertIssuance: () => request('requestUserCertIssuance'),
      onReceiveUserCertIssuance: ({ callback }: any) =>
        receive('receiveUserCertIssuance', callback),
      requestCertSignStandby: () => request('requestCertSignStandby'),
      onCertSignResult: ({ callback }: any) =>
        receive('onCertSignResult', callback),
    };
  };

  const request = os === OS.IOS ? iosRequest : aosRequest;
  const receive = os === OS.IOS ? iosReceive : aosReceive;

  return bridge(request, receive);
};

const bridgeKtMap: TBridgeMap = (bridgeKt, errorHandler, versionChecker) => {
  return {
    getParamInfo: (params) => {
      const {
        passAppId,
        srcCd,
        src_cd,
        queue_seq,
        track_cd,
        os_type,
        challengeSeq,
        hideHeader,
        satelliteCustSeq,
      } = params;
      return {
        passAppId: passAppId,
        srcCd: (srcCd || src_cd) ?? '',
        queueSeq: queue_seq,
        osType: os_type,
        trackCd: track_cd ?? '',
        challengeSeq: challengeSeq ?? '',
        hideHeader: hideHeader,
        satelliteCustSeq,
        version:
          new URLSearchParams(window.location.search).get('version') ??
          '99.99.99',
      };
    },
    getAppVersion: () => {
      return {
        version:
          new URLSearchParams(window.location.search).get('version') ??
          '99.99.99',
      };
    },
    openNativeWebView: ({ url, title, closeType }) => {
      withErrorHandler(
        () =>
          bridgeKt.requestWebView({
            url,
            title,
            buttonType: closeType === 'B' ? 'B' : 'N',
          }),
        versionChecker.requestWebView(),
        errorHandler,
      );
    },
    close: () => {
      withErrorHandler(
        () => bridgeKt.requestWebViewFinish(),
        versionChecker.requestWebViewFinish(),
        errorHandler,
      );
    },
    openExternalBrowser: (obj = { url: '' }) => {
      withErrorHandler(
        () => bridgeKt.requestExternalBrowser({ url: obj.url }),
        versionChecker.requestExternalBrowser(),
        errorHandler,
      );
    },
    goNativeMain: () => {
      withErrorHandler(
        () => bridgeKt.requestGoMain(),
        versionChecker.requestGoMain(),
        errorHandler,
      );
    },
    requestAddService: ({
      type,
      url,
      noneMemberUrl,
      paidMemberUrl,
      freeMemberUrl,
      needMoveAfterJoin,
    }) => {
      if (type === 'CREDIT') {
        withErrorHandler(
          () =>
            bridgeKt.requestAddService({
              type,
              url,
              noneMemberUrl,
              paidMemberUrl,
              freeMemberUrl,
              needMoveAfterJoin,
            }),
          versionChecker.requestAddService('CREDIT'),
          errorHandler,
        );
      } else {
        withErrorHandler(
          () => bridgeKt.requestAddService({ type, url }),
          versionChecker.requestAddService(),
          errorHandler,
        );
      }
    },
    onClickNativeBackKey: (callback) => {
      withErrorHandler(
        () => bridgeKt.onClickHWKeyBtn({ callback }),
        versionChecker.onClickNativeBackKey(),
      );
    },
    requestCustomerInfo: (obj = { thirdLoanYn: '' }) => {
      withErrorHandler(
        () => bridgeKt.requestCustomerInfo({ thirdLoanYn: obj.thirdLoanYn }),
        versionChecker.requestCustomerInfo(),
        errorHandler,
      );
    },
    requestAuthCheck: (obj = { pisAppToken: '' }) => {
      withErrorHandler(
        () => bridgeKt.requestAuthCheck({ pisAppToken: obj.pisAppToken }),
        versionChecker.requestAuthCheck(),
        errorHandler,
      );
    },
    onReceiveCustomerInfo: (callback) => {
      withErrorHandler(
        () => bridgeKt.receiveCustomerInfo({ callback }),
        versionChecker.receiveCustomerInfo(),
      );
    },
    onReceiveAuthCheck: (callback) => {
      withErrorHandler(
        () => bridgeKt.receiveAuthCheck({ callback }),
        versionChecker.receiveAuthCheck(),
      );
    },
    requestUserCertIssuanceStatus: () => {
      withErrorHandler(
        () => bridgeKt.requestUserCertIssuanceStatus(),
        versionChecker.requestUserCertIssuanceStatus(),
        errorHandler,
      );
    },
    onReceiveUserCertIssuanceStatus: (callback) => {
      withErrorHandler(
        () => bridgeKt.onReceiveUserCertIssuanceStatus({ callback }),
        versionChecker.onReceiveUserCertIssuanceStatus(),
      );
    },
    requestUserCertIssuance: () => {
      withErrorHandler(
        () => bridgeKt.requestUserCertIssuance(),
        versionChecker.requestUserCertIssuance(),
        errorHandler,
      );
    },
    onReceiveUserCertIssuance: (callback) => {
      withErrorHandler(
        () => bridgeKt.onReceiveUserCertIssuance({ callback }),
        versionChecker.onReceiveUserCertIssuance(),
      );
    },
    requestCertSignStandby: () => {
      withErrorHandler(
        () => bridgeKt.requestCertSignStandby(),
        versionChecker.requestCertSignStandby(),
        errorHandler,
      );
    },
    onCertSignResult: (callback) => {
      withErrorHandler(
        () => bridgeKt.onCertSignResult({ callback }),
        versionChecker.onCertSignResult(),
      );
    },
  };
};

export default (appVersion: string, errorHandler: () => void) => {
  const checker = createVersionChecker(
    appVersion,
    os === OS.IOS ? iosVersionDic : aosVersionDic,
  );
  const bridge = createBridgeKt(os);

  return bridgeKtMap(bridge, errorHandler, checker);
};
